import { getIntegrationManifest } from '@gonfalon/openapi/operations/getIntegrationManifest';
import { getIntegrationManifests } from '@gonfalon/openapi/operations/getIntegrationManifests';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getIntegrationManifestsQuery = createQueryOptions(getIntegrationManifests);

export const getIntegrationManifestQuery = createQueryOptions(getIntegrationManifest);
